import dynamic from 'next/dynamic';
import { useTextFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import type { ComponentsBulletList } from 'queries/graphql';

import Bullet from 'generic/Bullet';

import styles from './styles.module.scss';

const MarkdownText = dynamic(() => import('generic/MarkdownText'));

export default function BulletList({ sectionId, text, bullets, style }: ComponentsBulletList) {
  const { textColor, backgroundColor, textFont } = style || {};

  const textFontOverrides = useTextFontOverrides(textFont);

  return (
    <div id={sectionId} className={`root ${styles.container} bulletList`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${buildCssVar('--background-color', backgroundColor, 'var(--default-background-color)')}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      {text && (
        <div className={styles.text}>
          <MarkdownText text={text}></MarkdownText>
        </div>
      )}

      <div className={styles.bullets_wrapper}>
        {bullets.map(({ bullet }) => (
          <Bullet key={bullet.id} {...bullet} />
        ))}
      </div>
    </div>
  );
}
